import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./LearnAndLead.css";

gsap.registerPlugin(ScrollTrigger);

const LearnAndLead = () => {
  const heading1Ref = useRef(null);
  const heading2Ref = useRef(null);

  useEffect(() => {
    // Animation for Heading 1
    gsap.fromTo(
      heading1Ref.current,
      { x: "-100%", opacity: 0, webkitTextStroke: "2pxrgb(25, 31, 34)" },
      {
        x: "0%",
        opacity: 1,
        webkitTextStroke: "0pxrgb(4, 5, 5)",
        color: "#ff5722",
        duration: 1,
        scrollTrigger: {
          trigger: heading1Ref.current,
          start: "top 90%",
          end: "top 40%",
          scrub: true,
        },
      }
    );

    // Animation for Heading 2
    gsap.fromTo(
      heading2Ref.current,
      { x: "100%", opacity: 0, webkitTextStroke: "2pxrgb(2, 2, 2)" },
      {
        x: "0%",
        opacity: 1,
        webkitTextStroke: "0pxrgb(3, 3, 3)",
        color: "#ff5722",
        duration: 1,
        scrollTrigger: {
          trigger: heading2Ref.current,
          start: "top 90%",
          end: "top 40%",
          scrub: true,
        },
      }
    );
  }, []);

  return (
    <div className="learn-and-lead-container">
      <div className="learn-and-lead-content">
        <h1 ref={heading1Ref} className="learn-and-lead-heading heading1">
          Welcome to The Golden Palace
        </h1>
        <h1 ref={heading2Ref} className="learn-and-lead-heading heading2">
          A Luxuries Marriage Garden & Resort
        </h1>
      </div>
    </div>
  );
};

export default LearnAndLead;
